import React, { Component } from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import { Button } from '../features/button/index';
import Sidebar from './Sidebar';
import { TEXT } from '../../locals';
import { API } from '../../api';
import { URL } from '../../url';
import { ERROR_MESSAGES } from '../../error_messages';
import { setDelay, Push, setToken } from '../../util';
import SocialLogin from './SocialLogin';
import { ERROR_TYPES } from '../../errorTypes';

const { SIGN_IN_SIDEBAR } = TEXT.MAIN;

class LoginSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { error: '', disabled: false };
    this.email = React.createRef();
    this.password = React.createRef();
  }

  clearError = () => {
    const { error } = this.state;
    if (error) {
      this.setState({ error: '' });
    }
    const element = document.getElementById('login_email');
    element.classList.remove('error');
    const element1 = document.getElementById('login_password');
    element1.classList.remove('error');
  }

  toggleDisable = () => {
    this.setState(({ disabled }) => ({ disabled: !disabled }));
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {
      email, password, toggleDisable,
    } = this;
    const { closeAllSidebars } = this.props;
    toggleDisable();
    const data = {
      email: email.current.value,
      password: password.current.value,
    };
    axios({
      method: 'post',
      url: API.login,
      data,
    })
      .then((res) => {
        setDelay(() => {
          const { token } = res.data;
          toggleDisable();
          if (token) {
            closeAllSidebars();
            setToken(token);
            Push(URL.auth + token);
          } else {
            this.setError(ERROR_MESSAGES.TRY_AGAIN);
          }
        });
      })
      .catch((err) => {
        setDelay(() => {
          const { data: resData } = err.response || {};
          const { type } = resData || {};
          this.setError(ERROR_MESSAGES[type] || ERROR_MESSAGES.TRY_AGAIN);
          if (type === ERROR_TYPES.USER_NOT_FOUND) {
            const element = document.getElementById('login_email');
            element.classList.add('error');
          } else if (type === ERROR_TYPES.INCORRECT_PASSWORD) {
            const element1 = document.getElementById('login_password');
            element1.classList.add('error');
          }
          setDelay(toggleDisable);
        });
      });
  }

  setError = (error) => {
    this.setState({ error });
  }

  render() {
    const {
      forwardRef, toggleLoginSidebar, toggleRegistrationSidebar, toggleForgotSidebar, active, role,
      closeAllSidebars,
    } = this.props;
    const { error, disabled } = this.state;
    return (
      <Sidebar
        forwardRef={forwardRef}
        toggleShow={toggleLoginSidebar}
        active={active}
      >
        <form onSubmit={this.onSubmit}>
          <h2 className="title">{SIGN_IN_SIDEBAR.TITLE}</h2>
          <div className="info">
            <label htmlFor="login_email">
              <p>
                {SIGN_IN_SIDEBAR.INPUT.EMAIL}
                {error ? <span className="error-text">{` ${error}`}</span> : ''}
              </p>
              <input
                id="login_email"
                type="email"
                pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                className="email"
                placeholder={SIGN_IN_SIDEBAR.PLACEHOLDER.EMAIL}
                ref={this.email}
                onChange={this.clearError}
                disabled={disabled}
                required
              />
            </label>
            <label htmlFor="login_password">
              <p>{SIGN_IN_SIDEBAR.INPUT.PASSWORD}</p>
              <input
                id="login_password"
                type="password"
                className="password"
                placeholder={SIGN_IN_SIDEBAR.PLACEHOLDER.PASSWORD}
                ref={this.password}
                onChange={this.clearError}
                minLength={6}
                disabled={disabled}
                required
              />
            </label>
          </div>
          <div className="bottom">
            <div className="bottom-row">
              <button
                className="transparent-btn"
                onClick={() => {
                  toggleLoginSidebar(false);
                  toggleRegistrationSidebar(false);
                  toggleForgotSidebar(true);
                }}
                type="button"
              >
                {SIGN_IN_SIDEBAR.FORGOT_PASSWORD}
              </button>
              <Button
                type="submit"
                buttonProps={{
                  disabled,
                  className: 'main-btn submit',
                }}
                loaderClassName="light-loader"
                label={<h5>{SIGN_IN_SIDEBAR.SIGN_IN_BUTTON}</h5>}
                loading={disabled}
              />
            </div>
            <button
              className="transparent-btn"
              onClick={() => {
                toggleLoginSidebar(false);
                toggleRegistrationSidebar(true);
              }}
              type="button"
            >
              {SIGN_IN_SIDEBAR.SIGN_UP_BUTTON}
            </button>
          </div>
        </form>
        <SocialLogin
          setError={this.setError}
          role={role}
          closeAllSidebars={closeAllSidebars}
        />
      </Sidebar>
    );
  }
}
LoginSidebar.propTypes = {
  forwardRef: PropTypes.instanceOf(Object).isRequired,
  toggleLoginSidebar: PropTypes.func.isRequired,
  toggleRegistrationSidebar: PropTypes.func.isRequired,
  toggleForgotSidebar: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
  closeAllSidebars: PropTypes.func.isRequired,
};
export default LoginSidebar;
